module.exports = {
      id: "app-store-usage",
      viewBox: "0 0 144 48",
      url: __webpack_public_path__ + "svg-sprite-0ef3134280a050ca46b4726dfe0fed42.svg#app-store",
      toString: function () {
        return this.url;
      }
    }